import { createContext, useContext, useEffect, useMemo, useState, type ReactNode } from "react";

interface PageTitleContextValue {
  title: string;
  setTitle: (title: string) => void;
}

const PageTitleContext = createContext<PageTitleContextValue | null>(null);

/**
 * Titulo da tela atual, pra moldura do app mobile (handoff: barra fixa coral
 * com voltar + titulo centralizado no cabecalho, comportamento "Barras fixas
 * fazem parte da moldura do app"). PageHeader.tsx publica aqui via
 * useSetPageTitle; MobileHeader.tsx (dentro de Header.tsx) le com usePageTitle.
 * Evita prop-drilling do titulo pelas 19 telas — cada uma ja chama PageHeader.
 */
export function PageTitleProvider({ children }: { children: ReactNode }): JSX.Element {
  const [title, setTitle] = useState("Vitrine Hiit");
  const value = useMemo(() => ({ title, setTitle }), [title]);
  return <PageTitleContext.Provider value={value}>{children}</PageTitleContext.Provider>;
}

// eslint-disable-next-line react-refresh/only-export-components
export function usePageTitle(): PageTitleContextValue {
  const ctx = useContext(PageTitleContext);
  if (!ctx) throw new Error("usePageTitle precisa de PageTitleProvider");
  return ctx;
}

/** Publica o titulo da tela atual enquanto o componente estiver montado. */
// eslint-disable-next-line react-refresh/only-export-components
export function useSetPageTitle(title: string): void {
  const { setTitle } = usePageTitle();
  useEffect(() => {
    setTitle(title);
  }, [title, setTitle]);
}
